<div class="pme-right-rail-container" [class.mobile-view]="isMobile">
  <ion-header *ngIf="isMobile" class="ion-no-border ion-header-modal-desktop">
    <ion-toolbar>
      <ion-buttons slot="end">
        <ion-button
          (click)="onCloseSidebar()"
          class="close-button"
          data-cy="close-sidebar-button"
        >
          <ion-icon slot="icon-only" name="close-outline"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <div class="pme-right-rail-header">
    <div class="header-left-side">
      <ion-icon
        *ngIf="!product?.imageThumbnail"
        data-cy="product-card-no-image-icon"
        class="no-image"
        name="restaurant"
      ></ion-icon>
      <img
        *ngIf="product?.imageThumbnail"
        class="product-image"
        src="{{ product?.imageThumbnail }}"
        (error)="
          this.product.imageThumbnail = getAlternativeThumbnail(
            product?.imageThumbnail
          )
        "
        [attr.data-cy]="
          'price-mode-sidebar-product-' + product?.productNumber + '-image'
        "
      />
    </div>

    <div class="header-right-side">
      <div
        class="brand-name"
        [attr.data-cy]="
          'price-mode-sidebar-product-' + product?.productNumber + '-brand'
        "
      >
        {{ product?.summary?.brand }}
      </div>
      <div
        class="product-description"
        [attr.data-cy]="
          'price-mode-sidebar-product-' +
          product?.productNumber +
          '-description'
        "
      >
        {{ product?.summary?.productDescTxtl }}
      </div>
    </div>
  </div>

  <div class="header-details-section">
    <div
      class="product-details-header"
      [attr.data-cy]="
        'price-mode-sidebar-product-' + product?.productNumber + '-details'
      "
      style="flex: 1"
    >
      <span (click)="productDetailsButtonClick()">{{
        'i18n.lists.productDetails' | translate
      }}</span>
    </div>

    <app-product-card-promotions-banner
      *ngIf="product?.promotionDetails?.offerBenefitDesc"
      class="promotions-banner"
      [productNumber]="product?.productNumber"
      [offerBenefitDesc]="product?.promotionDetails?.offerBenefitDesc"
    ></app-product-card-promotions-banner>
    <!-- style="flex: 1" -->
  </div>

  <div *ngIf="isMobile" class="mobile-details-section">
    <div class="mobile-header-section">
      <div class="mobile-section">
        <div
          *ngIf="product?.easyPricingViewModel?.lastPrice?.unitPrice"
          class="listing"
        >
          <span class="listing-key"
            >{{ 'i18n.lists.lastWeek' | translate }}
          </span>
          <span data-cy="price-mode-sidebar-last-week">{{
            product?.easyPricingViewModel?.lastPrice?.unitPrice | currency
          }}</span>
        </div>
        <div *ngIf="product?.easyPricingViewModel?.wwp" class="listing">
          <span class="listing-key">WWP </span>
          <span data-cy="price-mode-sidebar-wwp">{{
            product?.easyPricingViewModel?.wwp
          }}</span>
        </div>

        <div
          *ngIf="product?.easyPricingViewModel?.targetDifference"
          class="listing"
        >
          <span class="listing-key"
            >{{ 'i18n.lists.targetDifference' | translate }}
          </span>
          <span
            *ngIf="product?.easyPricingViewModel?.targetDifference"
            data-cy="price-mode-sidebar-target-difference"
            >{{
              product?.easyPricingViewModel?.targetDifference | currency
            }}</span
          >
        </div>
      </div>

      <div class="mobile-section">
        <div
          *ngIf="product?.easyPricingViewModel?.zilliantDetails?.cprLowLimit"
          class="listing"
        >
          <span class="listing-key"
            >{{ 'i18n.lists.lowLimit' | translate }}
          </span>
          <span
            *ngIf="product?.easyPricingViewModel?.zilliantDetails?.cprLowLimit"
            data-cy="price-mode-sidebar-low-limit"
            >{{
              product?.easyPricingViewModel?.zilliantDetails?.cprLowLimit
                | currency
            }}</span
          >
        </div>
        <div
          *ngIf="product?.easyPricingViewModel?.rationale"
          class="listing rationale-listing"
        >
          <span class="listing-key rationale-key"
            >{{ 'i18n.lists.rationale' | translate }}
          </span>
          <span
            *ngIf="product?.easyPricingViewModel?.rationale"
            data-cy="price-mode-sidebar-rationale"
            >{{ product?.easyPricingViewModel?.rationale }}</span
          >
        </div>
      </div>
    </div>

    <div class="current-target-custom-section">
      <div class="current-week-section one-third-width">
        <div class="current-week-section-inner">
          <span>{{ 'i18n.lists.pmeList.currentWeek' | translate }}</span>
          <div class="current-price-value-container">
            <span
              *ngIf="!product?.easyPricingViewModel?.isReloading"
              class="current-week-price"
              data-cy="price-mode-sidebar-current-price"
            >
              {{
                product?.easyPricingViewModel?.currentPrice?.unitPrice
                  | currency
              }}
            </span>
            <ion-spinner
              *ngIf="product?.easyPricingViewModel?.isReloading"
              name="circles"
              data-cy="pme-current-week-spinner"
            ></ion-spinner>
            <div
              *ngIf="
                product?.easyPricingViewModel?.currentWeekDifference &&
                !product?.easyPricingViewModel?.isReloading
              "
              class="price-change-value"
              [class.negative]="
                product?.easyPricingViewModel?.currentWeekDifference < 0
              "
              data-cy="pme-price-change"
            >
              <span data-cy="pme-current-week-difference-value">
                {{
                  product?.easyPricingViewModel?.currentWeekDifference
                    | currency
                }}
              </span>
              <img
                *ngIf="product?.easyPricingViewModel?.currentWeekDifference"
                [src]="
                  product?.easyPricingViewModel?.currentWeekDifference > 0
                    ? 'assets/icon/up-arrow.svg'
                    : 'assets/icon/down-arrow.svg'
                "
                [alt]="
                  product?.easyPricingViewModel?.currentWeekDifference > 0
                    ? 'arrow-up'
                    : 'arrow-down'
                "
                data-cy="pme-current-week-difference-icon"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="target-case-price-section one-third-width">
        <div class="target-case-price-wrapper">
          <div class="value" data-cy="pme-target-case-price-label">
            {{ 'i18n.lists.pmeList.targetCasePrice' | translate }}
          </div>
          <div
            class="target-case-price-container"
            [class.selected]="
              product?.easyPricingViewModel?.isSuccess &&
              !product?.easyPricingViewModel?.isCustomUpdate
            "
            [class.disabled]="
              !product?.easyPricingViewModel?.isCprEnabled ||
              product?.easyPricingViewModel?.isProcessing
            "
            [class.error]="
              product?.easyPricingViewModel?.isError &&
              !product?.easyPricingViewModel?.isCustomUpdate
            "
            (click)="selectTargetPrice()"
          >
            <img
              *ngIf="
                product?.easyPricingViewModel?.isSuccess &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              src="assets/icon/checkmark-fill-green.svg"
              alt="checkmark"
              data-cy="pme-target-case-price-checkmark"
            />
            <ion-spinner
              *ngIf="
                product?.easyPricingViewModel?.isProcessing &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              name="circles"
              data-cy="pme-target-case-price-spinner"
            ></ion-spinner>
            <div
              class="target-case-price medium-font-weight"
              [class.selected]="
                product?.easyPricingViewModel?.isSuccess &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              [class.gray-text]="
                !product?.easyPricingViewModel?.isCprEnabled ||
                product?.easyPricingViewModel?.isProcessing
              "
              [class.error]="
                product?.easyPricingViewModel?.isError &&
                !product?.easyPricingViewModel?.isCustomUpdate
              "
              data-cy="pme-target-case-price-value"
            >
              {{
                product?.easyPricingViewModel?.targetCasePrice
                  ? (product?.easyPricingViewModel?.targetCasePrice | currency)
                  : '$0.00'
              }}
            </div>
          </div>
        </div>
      </div>
      <div class="custom-case-price-section one-third-width">
        <div class="custom-case-price-section-inner">
          <span>{{ 'i18n.lists.customCasePrice' | translate }}</span>
          <ion-item lines="none">
            <ion-input
              class="custom-price-input"
              [class.accepted]="
                product?.easyPricingViewModel?.isSuccess &&
                product?.easyPricingViewModel?.isCustomUpdate
              "
              [class.denied]="
                product?.easyPricingViewModel?.isError &&
                product?.easyPricingViewModel?.isCustomUpdate
              "
              [class.disabled]="
                !product?.easyPricingViewModel?.isCprEnabled ||
                product?.easyPricingViewModel?.isProcessing
              "
              [disabled]="
                !product?.easyPricingViewModel?.isCprEnabled ||
                product?.easyPricingViewModel?.isProcessing
              "
              inputmode="decimal"
              placeholder="$0.00"
              data-cy="pme-custom-price-input"
              [maxPrecision]="2"
              customDecimal
              [value]="product?.easyPricingViewModel?.customPrice | currency"
              (ionBlur)="onCustomPriceChange($event)"
            ></ion-input>
          </ion-item>
          <div
            class="price-change-status-wrapper"
            data-cy="pme-price-change-status-wrapper"
          >
            <div
              class="price-change-status regular-font-weight"
              [class.accepted]="
                product?.easyPricingViewModel?.isSuccess &&
                product?.easyPricingViewModel?.isCustomUpdate
              "
              [class.denied]="
                product?.easyPricingViewModel?.isError &&
                product?.easyPricingViewModel?.isCustomUpdate
              "
              data-cy="pme-price-change-status-value"
            >
              <img
                *ngIf="
                  product?.easyPricingViewModel?.isSuccess &&
                  product?.easyPricingViewModel?.isCustomUpdate
                "
                src="assets/icon/checkmark-fill-green.svg"
                alt="checkmark"
                class="checkmark-icon"
                data-cy="pme-price-change-status-checkmark"
              />
              {{
                (product?.easyPricingViewModel?.isSuccess &&
                product?.easyPricingViewModel?.isCustomUpdate
                  ? 'i18n.lists.pmeList.accepted'
                  : product?.easyPricingViewModel?.isError &&
                      product?.easyPricingViewModel?.isCustomUpdate
                    ? 'i18n.lists.pmeList.failed'
                    : product?.easyPricingViewModel?.isProcessing &&
                        product?.easyPricingViewModel?.isCustomUpdate
                      ? 'i18n.lists.pmeList.processing'
                      : ''
                ) | translate
              }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!isMobile" class="gpd-section">
    <div
      *ngIf="product?.easyPricingViewModel?.currentPrice?.grossProfitDollars"
      class="listing"
    >
      <span class="listing-key">GPD </span>
      <ng-container>
        <span data-cy="price-mode-sidebar-gpd">
          {{
            (product?.easyPricingViewModel?.currentPrice?.grossProfitDollars
              | currency) || 'N/A'
          }}
          <ng-container
            *ngIf="
              product?.easyPricingViewModel?.currentPrice?.grossProfitPercent
            "
            >({{
              product?.easyPricingViewModel?.currentPrice?.grossProfitPercent
            }}%)</ng-container
          >
        </span>
      </ng-container>
    </div>
    <div
      *ngIf="product?.easyPricingViewModel?.currentPrice?.marketChange"
      class="listing"
    >
      <span class="listing-key"
        >{{ 'i18n.lists.marketChange' | translate }}
      </span>
      <span data-cy="price-mode-sidebar-market-change">{{
        product?.easyPricingViewModel?.currentPrice?.marketChange | currency
      }}</span>
    </div>
    <div
      *ngIf="
        product?.summary?.breakable &&
        product?.easyPricingViewModel?.currentPrice?.breakSurchargeAmt
      "
      class="listing"
    >
      <span class="listing-key"
        >{{ 'i18n.lists.breakSurcharge' | translate }}
      </span>
      <span data-cy="price-mode-sidebar-break-surcharge">{{
        product?.easyPricingViewModel?.currentPrice?.breakSurchargeAmt
          | currency
      }}</span>
    </div>
    <div *ngIf="product?.easyPricingViewModel?.asc > 0" class="listing">
      <span class="listing-key">ASC </span>
      <span data-cy="price-mode-sidebar-asc"
        >{{ product?.easyPricingViewModel?.asc | currency }}
        {{
          product?.easyPricingViewModel?.currentPrice?.autoShippingCharges
            ?.ascApplyFlag
        }}
      </span>
    </div>
    <div class="listing">
      <span class="listing-key">{{ 'i18n.lists.eachPrice' | translate }} </span>
      <span data-cy="price-mode-sidebar-each-price">
        {{
          product?.summary?.breakable
            ? ((product?.easyPricingViewModel?.currentPrice?.eachPrice
                | currency) ?? 'N/A')
            : ((product?.easyPricingViewModel?.currentPrice?.unitPrice
                | currency) ?? 'N/A')
        }}
      </span>
    </div>
    <div *ngIf="product?.easyPricingTags?.length > 0">
      <app-usf-product-tag-list
        [tagList]="product?.easyPricingTags"
        [infoIconEnabled]="false"
        [allTagsClickable]="true"
        [product]="transformProductToProductDetail()"
        [maxTags]="6"
      ></app-usf-product-tag-list>
    </div>
  </div>

  <div *ngIf="isMobile" class="gpd-section-mobile">
    <!-- left side -->
    <div class="mobile-section">
      <div
        *ngIf="product?.easyPricingViewModel?.currentPrice?.grossProfitDollars"
        class="listing"
      >
        <span class="listing-key">GPD </span>
        <ng-container
          *ngIf="
            product?.easyPricingViewModel?.currentPrice?.grossProfitDollars
          "
        >
          <span data-cy="price-mode-sidebar-gpd">
            {{
              (product?.easyPricingViewModel?.currentPrice?.grossProfitDollars
                | currency) || 'N/A'
            }}
            <ng-container
              *ngIf="
                product?.easyPricingViewModel?.currentPrice?.grossProfitPercent
              "
              >({{
                product?.easyPricingViewModel?.currentPrice?.grossProfitPercent
              }}%)</ng-container
            >
          </span>
        </ng-container>
      </div>
      <div
        *ngIf="product?.easyPricingViewModel?.currentPrice?.marketChange"
        class="listing"
      >
        <span class="listing-key"
          >{{ 'i18n.lists.marketChange' | translate }}
        </span>
        <span
          *ngIf="product?.easyPricingViewModel?.currentPrice?.marketChange"
          data-cy="price-mode-sidebar-market-change"
          >{{
            product?.easyPricingViewModel?.currentPrice?.marketChange | currency
          }}</span
        >
      </div>
      <div *ngIf="product?.easyPricingViewModel?.asc > 0" class="listing">
        <span class="listing-key">ASC </span>
        <span data-cy="price-mode-sidebar-asc"
          >{{ product?.easyPricingViewModel?.asc | currency }}
          {{
            product?.easyPricingViewModel?.currentPrice?.autoShippingCharges
              ?.ascApplyFlag
          }}
        </span>
      </div>
    </div>

    <!-- Right side -->
    <div class="mobile-section">
      <div
        class="listing"
        *ngIf="
          product?.summary?.breakable &&
          product?.easyPricingViewModel?.currentPrice?.breakSurchargeAmt
        "
      >
        <span class="listing-key"
          >{{ 'i18n.lists.breakSurcharge' | translate }}
        </span>
        <span data-cy="price-mode-sidebar-break-surcharge">{{
          product?.easyPricingViewModel?.currentPrice?.breakSurchargeAmt
            | currency
        }}</span>
      </div>

      <div class="listing">
        <span *ngIf="product?.summary?.breakable" class="listing-key"
          >{{ 'i18n.lists.eachPrice' | translate }}
        </span>
        <span data-cy="price-mode-sidebar-each-price">
          {{
            product?.summary?.breakable
              ? ((product?.easyPricingViewModel?.currentPrice?.eachPrice
                  | currency) ?? 'N/A')
              : ((product?.easyPricingViewModel?.currentPrice?.unitPrice
                  | currency) ?? 'N/A')
          }}
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="isMobile && product?.easyPricingTags?.length > 0">
    <app-usf-product-tag-list
      [tagList]="product?.easyPricingTags"
      [infoIconEnabled]="false"
      [allTagsClickable]="true"
      [product]="transformProductToProductDetail()"
      [maxTags]="6"
    ></app-usf-product-tag-list>
  </div>
  <div
    *ngIf="product?.easyPricingViewModel?.lastBuys?.length > 0"
    class="last-4-buys-section"
  >
    <span class="listing-key">{{ 'i18n.lists.last4Buys' | translate }}</span>
    <div class="grid-wrapper">
      <table>
        <tr>
          <th>{{ 'i18n.lists.invDate' | translate }}</th>
          <td
            *ngFor="
              let buy of product?.easyPricingViewModel?.lastBuys?.slice(0, 4) ||
                [];
              let i = index
            "
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-inv-date-' +
              i
            "
          >
            {{ buy?.invoiceDate | date: 'M/d/yy' }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.invoices' | translate }}</th>
          <td
            *ngFor="
              let buy of product?.easyPricingViewModel?.lastBuys?.slice(0, 4) ||
                [];
              let i = index
            "
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-invoice-' +
              i
            "
          >
            {{ buy?.invoiceNumber }}
          </td>
        </tr>
        <tr>
          <th>WWP</th>
          <td
            *ngFor="
              let buy of product?.easyPricingViewModel?.lastBuys?.slice(0, 4) ||
                [];
              let i = index
            "
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-wwp-' +
              i
            "
          >
            {{ buy?.wwp }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.price' | translate }}</th>
          <td
            *ngFor="
              let buy of product?.easyPricingViewModel?.lastBuys?.slice(0, 4) ||
                [];
              let i = index
            "
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-price-' +
              i
            "
          >
            {{ buy?.price }}
          </td>
        </tr>
        <tr *ngIf="isTandemWorking">
          <th>{{ 'i18n.lists.targetPercent' | translate }}</th>
          <td
            *ngFor="let percentage of targetPercents.slice(0, 4); let i = index"
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-target-percent-' +
              i
            "
          >
            {{ percentage }}
          </td>
        </tr>
        <tr>
          <th>{{ 'i18n.lists.quantity' | translate }}</th>
          <td
            *ngFor="
              let buy of product?.easyPricingViewModel?.lastBuys?.slice(0, 4) ||
                [];
              let i = index
            "
            [attr.data-cy]="
              'price-mode-sidebar-product-' +
              product?.productNumber +
              '-quantity-' +
              i
            "
          >
            {{ buy?.qty }}
          </td>
        </tr>
        <tr *ngIf="isTandemWorking">
          <th>MTD</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr *ngIf="isTandemWorking">
          <th>{{ 'i18n.lists.department' | translate }}</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr *ngIf="isTandemWorking">
          <th>GPD</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
        <tr *ngIf="isTandemWorking">
          <th>GPP</th>
          <td *ngFor="let m of MTD.slice(0, 4)">{{ m }}</td>
        </tr>
      </table>
    </div>
  </div>
  <!-- Massage approvalStatus make uppercase in the selector-->
  <div class="crp-section" *ngIf="product?.easyPricingViewModel?.manualCpr">
    <!-- Approved CPR -->
    <div
      *ngIf="
        !(
          product?.easyPricingViewModel?.manualCpr?.approvalStatus ===
            'REJECTED' ||
          product?.easyPricingViewModel?.manualCpr?.approvalStatus === 'PENDING'
        )
      "
    >
      <div class="listing">
        <span class="listing-key">{{
          'i18n.lists.approvedCPR' | translate
        }}</span>
        <span data-cy="price-mode-sidebar-approved-cpr">{{
          product?.easyPricingViewModel?.manualCpr?.approvedPrice | currency
        }}</span>
      </div>
      <div class="listing">
        <span class="listing-key">{{
          'i18n.lists.approvedCPREnd' | translate
        }}</span>
        <span data-cy="price-mode-sidebar-approved-cpr-end">{{
          product?.easyPricingViewModel?.manualCpr?.approvedEndDateTime
            | date: 'MM/dd/yyyy'
        }}</span>
      </div>
    </div>
    <!-- Requested CPR -->
    <div *ngIf="product?.easyPricingViewModel?.manualCpr">
      <div class="listing">
        <span class="listing-key">{{
          'i18n.lists.requestedCPR' | translate
        }}</span>
        <span data-cy="price-mode-sidebar-requested-cpr">{{
          product?.easyPricingViewModel?.manualCpr?.requestedUnitPrice
            | currency
        }}</span>
      </div>
      <div class="listing">
        <span class="listing-key">{{
          'i18n.lists.requestedCPRDate' | translate
        }}</span>
        <span data-cy="price-mode-sidebar-requested-cpr-date">{{
          product?.easyPricingViewModel?.manualCpr?.requestDateTime
            | date: 'MM/dd/yyyy'
        }}</span>
      </div>
    </div>
  </div>
  <div
    *ngIf="
      product?.easyPricingViewModel?.driverName ||
      product?.easyPricingViewModel?.driverNumber
    "
    class="driver-section"
  >
    <div class="listing">
      <span class="listing-key">{{ 'i18n.lists.driver' | translate }}</span>

      <span data-cy="price-mode-sidebar-driver-info">
        <span
          *ngIf="
            product?.easyPricingViewModel?.driverName &&
            product?.easyPricingViewModel?.driverNumber
          "
          >{{ product.easyPricingViewModel.driverName }} ({{
            product.easyPricingViewModel.driverNumber
          }})</span
        >
        <span
          *ngIf="
            product?.easyPricingViewModel?.driverName &&
            !product?.easyPricingViewModel?.driverNumber
          "
          >{{ product.easyPricingViewModel.driverName }}</span
        >
        <span
          *ngIf="
            !product?.easyPricingViewModel?.driverName &&
            product?.easyPricingViewModel?.driverNumber
          "
          >{{ product.easyPricingViewModel.driverNumber }}</span
        >
      </span>
    </div>
  </div>
</div>
